import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { Box, Button, Grid, ThemeProvider, Tooltip } from "@mui/material";
import { useHistory, withRouter } from "react-router-dom";
import { createTheme } from "@mui/material/styles";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import createCache from "@emotion/cache";
import useCollapse from "react-collapsed";
import { useEffect, useState } from "react";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { Formik } from "formik";
import { createStyles, Theme, makeStyles } from "@material-ui/core";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import {
  ApiResultModel,
  ColumnModel,
  IList,
  PageInfoModel,
} from "../../../models/common.model";
import {
  BRANCHID,
  CACHEROUTE,
  STOREID,
  TABLE_FILTER,
} from "../../../config/cacheKey";
import MaterialTextFieldComponent from "../../../components/textField/MaterialTextFieldCmp";
import ChipCmp from "../../../components/chip/chipCmp";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {
  GetStoreListResponse,
  PaginationInfo,
} from "../../../models/store.model";

import DropdownCmp2 from "../../../components/dropdown/DropdownCmp2";
import {
  Filter,
  IBranchesRequest,
  IBranchesResponse,
} from "../../../models/branch.model";
import {
  BranchDelete,
  GetBranches,
  GetBranchesExcel,
} from "../../../services/branch.service";
import { useSelector } from "react-redux";
import ModalCancel from "../../../components/modals/ModalCancel";
import { toast } from "react-toastify";
import { CacheProvider } from "@emotion/react";
import AutocomplateCheckbox from "../../../components/dropdown/AutocomplateCheckbox";
import {
  GetAllIbanNumbers,
  GetAllStoresAndBranches,
  GetCities,
} from "../../../services/dropdown.service";
import { AllStoresAndBranchesResponse } from "../../../models/supplierUserBarnch.model";
import { IDropdownResponse } from "../../../models/dropdown.model";
import { set } from "lodash";

const useStyles = makeStyles((theme) =>
  createStyles({
    select: {
      "&.Mui-selected": {
        backgroundColor: muiSelected,
      },
    },
  })
);

const nextIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Next.png" />
  );
};
const previusIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Previous.png" />
  );
};

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

let muiSelected: any;

export default function BranchesTable() {
  const jsonFile = useSelector((state: any) => state.style);

  muiSelected = jsonFile?.secondColor_100;
  const useStyles = makeStyles((theme) =>
    createStyles({
      select: {
        "&.Mui-selected": {
          backgroundColor: muiSelected + "!important",
        },
      },
    })
  );
  const classes = useStyles();
  const [valueFilterData, setValueFilterData] = React.useState<Filter>();

  let row: any;
  const queryClient = useQueryClient();
  const history = useHistory<{
    from: string;
    id: number;
    pageNumber: number;
    clickOnBack: boolean;
    saleKey: string;
    branchId: number;
    customerPersonId: number;
  }>();
  const [isExpanded, setExpanded] = useState(true);
  const [data, setData] = useState<IBranchesResponse[]>([]);
  const [branchActive, setBranchActive] = useState<
    { id: number; title: string; enumData: boolean }[]
  >([]);
  const [branchTypeActive, setBranchTypeActive] = useState<
    { id: number; title: string; enumData: string }[]
  >([]);
  const [valueTitle, setValueTitle] = useState<string>();
  const [valueBranchTitle, setValueBranchTitle] = useState<string>();
  const [valueBranch, setValueBranch] = useState<string>();
  const [valueIsActive, setValueIsActive] = useState<string>();
  const [valueIsActiveSelect, setValueIsActiveSelect] = useState<boolean>();
  const [valueBranchSelect, setValueBranchSelect] = useState<string>();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [branchId, setBranchId] = useState<number>();
  const [ibanId, setIbanId] = useState<any[]>([]);
  const [ibanTitle, setIbanTitle] = useState<any[]>([]);
  const [ibanResponse, setIbanResponse] = useState<any[]>([]);
  const [storeId, setStoreId] = useState<IList[]>([]);
  const [storeTitle, setStoreTitle] = useState<any[]>([]);
  const [storeResponse, setStoreResponse] = useState<any[]>([]);
  const [cityId, setCityId] = useState<any[]>([]);
  const [cityTitle, setCityTitle] = useState<any[]>([]);
  const [cityResponse, setCityResponse] = useState<any[]>([]);
  const [inputVal, setInputVal] = useState<string>("");
  const [allCityData, setAllCityData] = useState<IDropdownResponse[]>([]);
  const [allIbanData, setAllIbanData] = useState<IDropdownResponse[]>([]);
  const [allStoreData, setAllStoreData] = useState<
    AllStoresAndBranchesResponse[]
  >([]);
  const previousPage =
    history.location.state !== undefined ? history.location.state.from : null;

  const columns: readonly ColumnModel[] = [
    { id: "storeTitle", label: "عنوان فروشگاه" },
    { id: "branchTitle", label: "عنوان شعبه" },
    { id: "branchTypeTitle", label: " نوع شعبه" },
    {
      id: "isActive",
      label: "وضعیت شعبه",
    },

    { id: "ibanOwnerName", label: "شماره شبا" },
    { id: "provinceCityTitle", label: "استان / شهر محل " },
  ];
  const { getCollapseProps, getToggleProps } = useCollapse({
    isExpanded,
    collapsedHeight: 0,
  });
  const [pageInfo, setPageInfo] = React.useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = {} as PageInfoModel;
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;

      return pageInfoModel;
    }
  );
  //service call dropDown
  const { mutate: GetAllStoresAndBranchesMutate } = useMutation(
    GetAllStoresAndBranches,
    {
      onSuccess: (data: AllStoresAndBranchesResponse[]) => {
        if (data) {
          setAllStoreData(data);
        }
      },
      onError: () => {},
    }
  );
  const { mutate: GetCitiesMutate } = useMutation(GetCities, {
    onSuccess: (data: ApiResultModel<IDropdownResponse[]>) => {
      if (data) {
        setAllCityData(data.data);
      }
    },
    onError: () => {},
  });
  const { mutate: GetAllIbanNumbersMutate } = useMutation(GetAllIbanNumbers, {
    onSuccess: (data: ApiResultModel<IDropdownResponse[]>) => {
      if (data) {
        setAllIbanData(data.data);
      }
    },
    onError: () => {},
  });
  //service call dropDown
  localStorage.setItem(CACHEROUTE, "branch");
  const [currentPaginationInfo, setCurrentPaginationInfo] = React.useState(
    (): PaginationInfo => {
      let paginationInfo = new PaginationInfo();
      paginationInfo.pageNumber =
        history.location.state != undefined
          ? history.location.state.pageNumber
          : 1;
      return paginationInfo;
    }
  );

  useEffect(() => {
    const options = [
      { id: 1, title: "فعال", enumData: true },
      { id: 2, title: "غیرفعال", enumData: false },
    ];
    const branchTypeOptions = [
      { id: 1, title: "حضوری", enumData: "Onsite" },
      { id: 2, title: "آنلاین", enumData: "Online" },
    ];
    setBranchActive(options);
    setBranchTypeActive(branchTypeOptions);
    GetAllStoresAndBranchesMutate({});
    GetAllIbanNumbersMutate({});
    GetCitiesMutate({});
    let filterData;
    if (
      previousPage !== null ||
      (history.action === "REPLACE" &&
        history.location.state !== undefined &&
        history.location.state.clickOnBack)
    ) {
      filterData = queryClient.getQueryData<Filter>(TABLE_FILTER);
      if (filterData !== undefined && filterData !== null) {
        // setCityTitle(filterData!.storeTitle!);
        setValueIsActiveSelect(filterData!.isActive!);
        setValueBranchSelect(filterData!.branchType!);
      }
    } else {
      filterData = null;
      queryClient.setQueryData(TABLE_FILTER, null);
      let filter = {} as Filter;
      setValueFilterData(filter);
    }
    fillData(filterData!);
  }, []);

  const { mutateAsync: GetBranchesMutate } = useMutation(GetBranches, {
    onSuccess: (data: ApiResultModel<IBranchesResponse[]>) => {
      setData(data.data!);
      setPageInfo(data.pageInfo);
    },
  });

  const { mutateAsync: GetBranchesExcelMutate } = useMutation(
    GetBranchesExcel,
    {
      onSuccess: (result) => {},
      onError: (e) => {},
    }
  );
  const { mutate: BranchDeleteMutate } = useMutation(BranchDelete, {
    onSuccess: (data: ApiResultModel<boolean>) => {
      if (data.isSuccess) {
        toast.success("عملیات حذف شعبه انجام شد");
        fillData({} as Filter);
        setOpenModal(false);
      }
    },
    onError: () => {},
  });
  const handleDeleteBranch = () => {
    BranchDeleteMutate({ id: Number(branchId!) });
  };

  const setChildCityTitle = (childValues: any) => {
    let delValue = allCityData.filter(
      (item: any) => item.title === childValues
    );
    let titleValue = cityTitle.filter((item: any) => item !== childValues);
    setCityTitle(titleValue);

    const updatedRenderOption = cityResponse?.filter(
      (item: any) => item.id !== delValue[0].id
    );
    setCityResponse(updatedRenderOption);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    const updatedFilter = tabelFilter?.cityIds?.filter(
      (id: number) => id !== delValue[0].id
    );
    setCityId(updatedFilter ?? []);
    if (updatedFilter !== undefined && updatedFilter !== null) {
      tabelFilter!.cityIds = updatedFilter;
    }

    // if (tabelFilter !== undefined && tabelFilter !== null)
    //   tabelFilter!.title = undefined;
    fillData(tabelFilter!);
  };
  const setChildIbanTitle = (childValues: any) => {
    let delValue = allIbanData.filter(
      (item: any) => item.title === childValues
    );
    let titleValue = ibanTitle.filter((item: any) => item !== childValues);
    setIbanTitle(titleValue);

    const updatedRenderOption = ibanResponse?.filter(
      (item: any) => item.id !== delValue[0].id
    );
    setIbanResponse(updatedRenderOption);
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    const updatedFilter = tabelFilter?.ibanIds?.filter(
      (id: number) => id !== delValue[0].id
    );
    setIbanId(updatedFilter ?? []);
    if (updatedFilter !== undefined && updatedFilter !== null) {
      tabelFilter!.ibanIds = updatedFilter;
    }

    // if (tabelFilter !== undefined && tabelFilter !== null)
    //   tabelFilter!.title = undefined;
    fillData(tabelFilter!);
  };
  const setChildStoreTitle = (childValues: any) => {
    let delValue = allStoreData.filter(
      (item: any) => item.title === childValues
    );
    let titleValue = storeTitle.filter((item: any) => item !== childValues);
    setStoreTitle(titleValue);

    const updatedRenderOption = storeResponse?.filter(
      (item: any) =>
        item.parentId !== delValue[0].parentId ||
        item.childId !== delValue[0].childId
    );
    setStoreResponse(updatedRenderOption);

    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    const updatedFilter = tabelFilter?.branchStoreIds?.filter(
      (item: any) =>
        item.parentId !== delValue[0].parentId ||
        item.childId !== delValue[0].childId
    );
    setStoreId(updatedFilter ? updatedFilter : []);
    if (updatedFilter !== undefined && updatedFilter !== null) {
      tabelFilter!.branchStoreIds = updatedFilter;
    }

    // if (tabelFilter !== undefined && tabelFilter !== null)
    //   tabelFilter!.title = undefined;
    fillData(tabelFilter!);
    //

    // fillData(tabelFilter!);
  };

  const setChildValueIsActive = (childValues: any) => {
    const selectedItem = undefined;
    setValueIsActiveSelect(selectedItem);
    setValueIsActive("");
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    if (tabelFilter !== undefined && tabelFilter !== null)
      tabelFilter.isActive = undefined;
    fillData(tabelFilter!);
  };
  const setChildValueBranch = (childValues: any) => {
    const selectedItem = undefined;
    setValueBranchSelect(selectedItem);
    setValueBranch("");
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    if (tabelFilter !== undefined && tabelFilter !== null)
      tabelFilter.branchType = undefined;
    fillData(tabelFilter!);
  };

  const handleSelectedIsActive = (e: any, value: any) => {
    setValueIsActiveSelect(e.target.value!);
    setValueIsActive(value.props.children!);
  };
  const handleSelectedBranchType = (e: any, value: any) => {
    setValueBranchSelect(e.target.value!);
    setValueBranch(value.props.children!);
  };

  const generateFilter = (filterData: Filter): IBranchesRequest => {
    let request = {} as IBranchesRequest;
    request.paginationInfo = currentPaginationInfo;
    request.filter = filterData;
    return request;
  };

  const fillData = (filterData: Filter) => {
    let filter = generateFilter(filterData);
    GetBranchesMutate(filter);
    setValueFilterData(filter?.filter);
  };

  const changePageNumber = (newPageNumber: number) => {
    const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
    fillData(tabelFilter!);
    currentPaginationInfo.pageNumber = newPageNumber;
    setCurrentPaginationInfo(currentPaginationInfo);
  };

  const handleChangePagination = (event: any, value: any) => {
    changePageNumber(value);
  };

  function changeValueTitle(e: any) {
    setValueTitle(e.currentTarget.value);
  }

  function changeValuebranchTitle(e: any) {
    setValueBranchTitle(e.currentTarget.value);
  }
  function changeValueStore(e: any, value: any) {
    setStoreTitle(value.map((item: any) => item.title));
    setStoreId(
      value.map((item: any) => ({
        parentId: item.parentId,
        childId: item.childId,
      }))
    );
    setStoreResponse(value);
  }
  function changeValueIban(e: any, value: any) {
    setIbanTitle(value.map((item: any) => item.title));
    setIbanId(value.map((item: any) => item.id));
    setIbanResponse(value);
  }
  function changeValueCity(e: any, value: any) {
    setCityTitle(value.map((item: any) => item.title));
    setCityId(value.map((item: any) => item.id));
    setCityResponse(value);
  }

  function deleteChip() {
    setCityId([]);
    setCityTitle([]);
    setIbanId([]);
    setIbanTitle([]);
    setStoreId([]);
    setStoreTitle([]);
    setCityResponse([]);
    setIbanResponse([]);
    setStoreResponse([]);
    setValueIsActive("");
    setValueIsActiveSelect(undefined);
    setValueBranchSelect(undefined);
    queryClient.setQueryData(TABLE_FILTER, null);
    fillData(queryClient.getQueryData(TABLE_FILTER)!);
    currentPaginationInfo.pageNumber = 1;
    setCurrentPaginationInfo(currentPaginationInfo);
  }
  const filter = {} as Filter;
  const handelDetail = (referenceKey: string) => {
    window.sessionStorage.setItem("idFind", referenceKey);
    window.sessionStorage.setItem("loanRequestId", "");
    window.sessionStorage.setItem("natinalCode", "");
    localStorage.setItem(
      "SUPPLIER_REQUEST_DATA",
      JSON.stringify({ referenceKey: referenceKey })
    );
    const newWindow = window.open(
      "/#/Search/SupplierSearch1/request-find-detail",
      "_blank"
    );
    newWindow?.history.pushState(
      {
        settlementData: { referenceKey: referenceKey },
      },
      "",
      "/Search/SupplierSearch1/request-find-detail"
    );
  };

  const [isShow, setIsShow] = useState(true);
  let handelFilter = () => {
    setIsShow(!isShow);
  };
  const handleEditBranch = (e: any) => {
    localStorage.setItem(BRANCHID, e);
    history.push("/store/BranchRegister");
  };
  const handleBranchUser = (e: any) => {
    localStorage.setItem(BRANCHID, e);
    history.push("/store/BranchUserTable");
  };
  let exportExcel = () => {
    const emptyFilter = {} as Filter;
    GetBranchesExcelMutate(valueFilterData ? valueFilterData! : emptyFilter);
  };

  return (
    <div>
      <Button
        onClick={() => {
          localStorage.removeItem(STOREID);
          localStorage.removeItem(BRANCHID);
          history.push("/store/BranchRegister");
        }}
      >
        <AddCircleOutlineIcon />
        <span
          style={{ fontWeight: "bold", fontSize: "14px", paddingRight: "5px" }}
        >
          افزودن شعبه
        </span>
      </Button>
      <span style={{ margin: "2vh", color: "#CFD8DC" }}>|</span>
      <Tooltip title="فیلتر" arrow>
        <img
          onClick={handelFilter}
          style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
          src="images/filter.png"
        />
      </Tooltip>
      <span style={{ margin: "2vh", color: "#CFD8DC" }}>|</span>
      <Tooltip title="خروجی اکسل" arrow>
        <img
          onClick={exportExcel}
          className="cursorPointer"
          style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
          src="images/ExportXLS.svg"
        />
      </Tooltip>
      {isShow ? (
        <Box sx={{ flexGrow: 1 }}>
          <Formik
            initialValues={filter}
            onSubmit={(values: Filter) => {
              values.isActive = valueIsActiveSelect;
              values.branchType = valueBranchSelect;
              values.branchStoreIds = storeId;
              values.cityIds = cityId;
              values.ibanIds = ibanId;
              queryClient.setQueryData(TABLE_FILTER, values);
              fillData(values);
              currentPaginationInfo.pageNumber = 1;
              setCurrentPaginationInfo(currentPaginationInfo);
            }}
          >
            {({ handleSubmit, handleChange, values }) => (
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <>
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <div
                          className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                          style={{ paddingTop: "30px", direction: "rtl" }}
                        >
                          <AutocomplateCheckbox
                            id="storeId"
                            name="storeId"
                            value={storeId}
                            label={"عنوان فروشگاه"}
                            options={allStoreData!}
                            onChange={changeValueStore}
                            changeMultiSelect={changeValueStore}
                            responseValue={storeResponse}
                            inputVal={inputVal}
                          />
                        </div>
                      </ThemeProvider>
                    </CacheProvider>
                  </>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ paddingTop: "30px" }}
                  >
                    <DropdownCmp2
                      onChange={handleSelectedIsActive}
                      value={valueIsActiveSelect ?? ""}
                      label={"وضعیت شعبه "}
                      options={branchActive}
                      name="isActive"
                      id="isActive"
                      paddingRight={"0px"}
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ paddingTop: "30px" }}
                  >
                    <DropdownCmp2
                      onChange={handleSelectedBranchType}
                      value={valueBranchSelect ?? ""}
                      label={"نوع شعبه "}
                      options={branchTypeActive}
                      name="branchType"
                      id="branchType"
                      paddingRight={"0px"}
                    />
                  </div>

                  <>
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <div
                          className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                          style={{ paddingTop: "30px", direction: "rtl" }}
                        >
                          <AutocomplateCheckbox
                            id="Iban"
                            name="Iban"
                            value={ibanId}
                            label={"شماره شبا"}
                            options={allIbanData!}
                            onChange={changeValueIban}
                            changeMultiSelect={changeValueIban}
                            responseValue={ibanResponse}
                            inputVal={inputVal}
                          />
                        </div>
                      </ThemeProvider>
                    </CacheProvider>
                  </>
                  <>
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <div
                          className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                          style={{ paddingTop: "30px", direction: "rtl" }}
                        >
                          <AutocomplateCheckbox
                            id="cityId"
                            name="cityId"
                            value={cityId}
                            label={"استان/شهر"}
                            options={allCityData!}
                            onChange={changeValueCity}
                            changeMultiSelect={changeValueCity}
                            responseValue={cityResponse}
                            inputVal={inputVal}
                          />
                        </div>
                      </ThemeProvider>
                    </CacheProvider>
                  </>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 butFilter"
                    style={{ paddingTop: "30px" }}
                  >
                    <Button
                      fullWidth
                      variant="contained"
                      type="submit"
                      className="btnForm SuccessDefault  "
                    >
                      اعمال فیلتر
                    </Button>
                  </div>
                </div>

                {cityTitle.length > 0 ||
                ibanTitle.length > 0 ||
                storeTitle.length > 0 ||
                valueBranchTitle ||
                valueIsActiveSelect?.valueOf ? (
                  <div className="row tableCMP">
                    <Grid container xs={12}>
                      <Grid
                        item
                        xs={0.5}
                        style={{ marginTop: "10px", maxWidth: "fit-content" }}
                      >
                        <Button
                          onClick={deleteChip}
                          style={{
                            justifyContent: "right",
                            minWidth: "25px",
                            marginRight: "-1vh",
                          }}
                        >
                          <img
                            style={{ height: "24px", width: "24px" }}
                            src="images/RemoveAllFilters.svg"
                          />
                        </Button>
                      </Grid>
                      <Grid item xs={11.5}>
                        <ChipCmp
                          item={valueIsActive}
                          enamValue={valueIsActive}
                          index={valueIsActive?.length}
                          setChildValue={setChildValueIsActive}
                        />
                        <ChipCmp
                          item={valueBranch}
                          enamValue={valueBranch}
                          index={valueBranch?.length}
                          setChildValue={setChildValueBranch}
                        />

                        {cityTitle.map((title, index) => (
                          <ChipCmp
                            key={index}
                            item={title}
                            enamValue={title}
                            index={index}
                            setChildValue={setChildCityTitle}
                          />
                        ))}
                        {ibanTitle.map((title, index) => (
                          <ChipCmp
                            key={index}
                            item={title}
                            enamValue={title}
                            index={index}
                            setChildValue={setChildIbanTitle}
                          />
                        ))}
                        {storeTitle.map((title, index) => (
                          <ChipCmp
                            key={index}
                            item={title}
                            enamValue={title}
                            index={index}
                            setChildValue={setChildStoreTitle}
                          />
                        ))}
                      </Grid>
                    </Grid>
                  </div>
                ) : (
                  ""
                )}
              </form>
            )}
          </Formik>
        </Box>
      ) : (
        ""
      )}
      <br />

      <div className="cardTableBorder ">
        <TableContainer
          style={{ background: "#fff", direction: "rtl" }}
          className={`${data?.length > 0 ? "boxScrollSubmit" : ""}`}
        >
          <Table
            stickyHeader
            aria-label="sticky table "
            style={{ borderCollapse: "collapse" }}
          >
            <TableHead className="rowTHead" style={{ paddingBottom: "10px" }}>
              <TableRow
                classes={{ root: classes.select }}
                className={`${classes} borderRight borderLeft`}
              >
                <TableCell
                  className="rowTHead colorTitle textFont12 fontWeight"
                  align="right"
                  style={{ width: "5px" }}
                >
                  ردیف
                </TableCell>
                {columns?.map((column) => (
                  <TableCell
                    className="rowTHead colorTitle textFont12 fontWeight nowrapClass"
                    key={column.id}
                    align="right"
                  >
                    {column.label}
                  </TableCell>
                ))}
                <TableCell
                  className="rowTHead colorTitle textFont12 fontWeight"
                  align="right"
                  style={{ width: "10vh", minWidth: "10vh" }}
                >
                  آدرس
                </TableCell>
                <TableCell
                  className="rowTHead colorTitle textFont12 fontWeight stickyColELeft"
                  align="right"
                  style={{ width: "10vh", minWidth: "10vh" }}
                >
                  <MoreHorizIcon />
                </TableCell>
              </TableRow>
            </TableHead>
            <div style={{ width: "100%", height: "10px" }}></div>

            <TableBody
              style={{
                height: "30px",
                minHeight: "30px",
              }}
            >
              {data?.map((row, rowIndex) => {
                return (
                  <TableRow
                    classes={{ root: classes.select }}
                    className={`${
                      rowIndex % 2 == 0
                        ? "rowTBodyE  borderRight borderLeft"
                        : "rowTBodyO  borderRight borderLeft"
                    }${classes} borderRight borderLeft cursorPointer noWrap`}
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    // key={row.loanRequestId}
                    // selected={selectedRow === rowIndex}
                    // onClick={() => handelDetail(row.referenceKey)}
                  >
                    <TableCell className="textFont12" style={{ width: "5px" }}>
                      {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                        (currentPaginationInfo.pageSize! ?? 0) +
                        rowIndex +
                        1}
                    </TableCell>
                    {columns?.map((column) => {
                      const value = row[column.id as keyof IBranchesResponse];
                      return (
                        <TableCell
                          className="textFont12 nowrapClass"
                          key={column.id}
                          align="right"
                        >
                          {column.format && column.hasFormat ? (
                            column.format(value)
                          ) : column.id === "isActive" ? (
                            value === true ? (
                              <b style={{ color: "#28A745" }}>فعال</b>
                            ) : (
                              <b style={{ color: "#E6123D" }}>غیرفعال</b>
                            )
                          ) : (
                            value
                          )}
                        </TableCell>
                      );
                    })}
                    <TableCell className="textFont12 nowrapClass" align="right">
                      {row.address || row.url}
                    </TableCell>
                    <TableCell
                      sx={{
                        display: "flex",
                        gap: "5px",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      align="center"
                      component="th"
                      scope="row"
                      className={
                        rowIndex % 2 == 0
                          ? " stickyColOLeft   "
                          : " stickyColELeft  "
                      }
                    >
                      <PeopleAltOutlinedIcon
                        sx={{
                          color: "#1D4A87",
                          fontSize: "1.8rem",
                          cursor: "pointer",
                        }}
                        onClick={(e) => {
                          handleBranchUser(row.id);
                        }}
                      />
                      <EditOutlinedIcon
                        sx={{
                          color: "#1D4A87",
                          fontSize: "1.8rem",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleEditBranch(row.id);
                        }}
                      />
                      <DeleteOutlineIcon
                        sx={{
                          color: "#1D4A87",
                          fontSize: "1.8rem",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setOpenModal(true);
                          setBranchId(row.id);
                        }}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div>
        <Grid container spacing={2} alignItems="center">
          <Grid
            item
            xs={12}
            sm={4}
            display="flex"
            justifyContent={{ xs: "center", sm: "flex-start" }}
          >
            <span
              style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
            >
              تعداد کل :
              <span style={{ color: "#01AF43" }}>{pageInfo.total}</span> مورد
            </span>
          </Grid>
          <Grid item xs={12} sm={4} display="flex" justifyContent="center">
            <Pagination
              renderItem={(item) => (
                <PaginationItem
                  components={{
                    previous: previusIcon,
                    next: nextIcon,
                  }}
                  {...item}
                />
              )}
              sx={{
                direction: "ltr",
                margin: "5px",
                button: {
                  color: "#25D1C9",
                  fontSize: "14px !important",
                  fontFamily: "iranSans",
                },
              }}
              count={Math.ceil(pageInfo.total / pageInfo.pageSize)}
              onChange={handleChangePagination}
              page={currentPaginationInfo.pageNumber}
            />
          </Grid>
          <Grid item xs={12} sm={4}></Grid>
        </Grid>
      </div>
      <ModalCancel
        title={""}
        bgColor={"kamanColor"}
        setValue={handleDeleteBranch}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
    </div>
  );
}
